import { Icon } from "@mui/material";
import AuthWall from "modules/AuthWall/AuthWall";
import OrganizationSettingsPage from "pages/organization/settings";
import OrganizationSubscriptionPage from "pages/organization/subscription";
import OrganizationAddressesPage from "pages/organization/addresses";
import OrganizationAddressCreatePage from "pages/organization/addresses/create";
import OrganizationAddressEditPage from "pages/organization/addresses/edit";
import OrganizationEquipmentPiecesPage from "pages/organization/equipmentPieces";
import OrganizationEquipmentPieceCreatePage from "pages/organization/equipmentPieces/create";
import OrganizationEquipmentPieceEditPage from "pages/organization/equipmentPieces/edit";
import OrganizationAdditionalCostsPage from "pages/organization/additionalCosts";
import OrganizationAdditionalCostCreatePage from "pages/organization/additionalCosts/create";
import OrganizationAdditionalCostEditPage from "pages/organization/additionalCosts/edit";
import OrganizationTransferTrucksPage from "pages/organization/transferTrucks";
import OrganizationTransferTruckCreatePage from "pages/organization/transferTrucks/create";
import OrganizationTransferTruckEditPage from "pages/organization/transferTrucks/edit";
import OrganizationCrewsPage from "pages/organization/crews";
import OrganizationCrewCreatePage from "pages/organization/crews/create";
import OrganizationCrewEditPage from "pages/organization/crews/edit";
import DataUploadsPage from "pages/organization/dataUploads";
import DataUploadsImportPage from "pages/organization/dataUploads/create";
// import OrganizationPlantsCreatePage from "pages/organization/plants/create";
import OrganizationPlantsPage from "pages/organization/plants";
import OrganizationPlantsCreatePage from "pages/organization/plants/create";
import OrganizationPlantsEditPage from "pages/organization/plants/edit";
import ProposalSettingsPage from "pages/organization/proposal-settings";
import EmailSettingsPage from "pages/organization/email-settings";
import EmailSendingPage from "pages/organization/email-sending";
import EmployeesListPage from "pages/organization/employees";
import ArchivedEmployeesPage from "pages/organization/employees/archived";
import CreateEmployeePage from "pages/organization/employees/create";
import EditEmployeePage from "pages/organization/employees/edit";
import UpdateOrganizationPage from "pages/organization/update";
import UsersPage from "pages/users";
import ArchivedUsersPage from "pages/users/archived";
import NotificationsIndex from "pages/notifications";
import NotificationsEdit from "pages/notifications/edit";
import NotificationsCreate from "pages/notifications/create";
import ApiTriggerDeliveries from "pages/organization/api-triggers/deliveries";
import OrganizationProductTypesPage from "pages/organization/product-types";
import ProductGroupsPage from "pages/organization/product-groups";
import ProductGroupCreatePage from "pages/organization/product-groups/create";
import ProductGroupUpdatePage from "pages/organization/product-groups/update";
import Reports from "pages/organization/reports";
import ReportsView from "pages/organization/reports/view";
import ReportsAdditionalCostDetail from "pages/organization/reports/types/additionalCostDetail";
import AuthWallSubscriber from "modules/AuthWallSubscriber/AuthWallSubscriber";
import OrganizationLinkedServices from "pages/organization/linkedServices";
import FinalizeOrganizationLinkedService from "pages/organization/linkedServices/finalize";
import QuickbooksSettings from "pages/organization/linkedServices/Quickbooks/settings";
import QuickbooksDesktopQueueList from "pages/organization/linkedServices/Quickbooks/queueList";
import ProjectFiles from "pages/organization/projectFiles";
import { UserPermissions } from "generated/graphql";
import UserPermissionsPage from "pages/organization/userPermissions";
import AuthWallAdmin from "modules/AuthWallAdmin/AuthWallAdmin";
import ReportsCompanyOrClientDetails from "pages/organization/reports/types/companyOrClientDetails";
import ReportsContactDetails from "pages/organization/reports/types/contactDetails";
import ReportsCrewDetails from "pages/organization/reports/types/crewDetails";
import ReportsEquipmentCostDetails from "pages/organization/reports/types/equipmentCostDetails";
import ReportsJobsByContact from "pages/organization/reports/types/jobsByContact";
import ReportsJobCostByProductType from "pages/organization/reports/types/jobCostByProductType";
import ReportsJobCostingLapsed from "pages/organization/reports/types/jobCostingLapsed";
import ReportsJobCostDetail from "pages/organization/reports/types/jobCostDetail";
import ReportsJobDetails from "pages/organization/reports/types/jobDetails";
import ReportsOrganizationProfitability from "pages/organization/reports/types/organizationProfitability";
import ReportsOutstandingWork from "pages/organization/reports/types/outstandingWork";
import ReportsProductDetails from "pages/organization/reports/types/productDetails";
import ReportsProposalDetails from "pages/organization/reports/types/proposalDetails";
import ReportsSalesByContact from "pages/organization/reports/types/salesByContact";
import ReportsSalesByProductSummary from "pages/organization/reports/types/salesByProductSummary";
import ReportsSalesByProposalSource from "pages/organization/reports/types/salesByProposalSource";
import ReportsTimeEntries from "pages/organization/reports/types/timeEntries";
import ReportsYearOverYearRevenue from "pages/organization/reports/types/yearOverYearRevenue";

const organizationRoutes = [
  {
    type: "collapse",
    name: "Product Settings",
    key: "organization",
    permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
    icon: <Icon fontSize="medium">factory</Icon>,
    collapse: [
      {
        name: "Products",
        key: "product-types.list",
        route: "/product-types",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        icon: <Icon fontSize="medium">add_road</Icon>,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationProductTypesPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Product Groups",
        key: "product-groups.list",
        route: "/product-groups",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        icon: <Icon fontSize="medium">category</Icon>,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <ProductGroupsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Product Group",
        key: "product-groups.create",
        route: "/product-groups/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <ProductGroupCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Update Product Group",
        key: "product-groups.update",
        route: "/product-groups/:productGroupId/update",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <ProductGroupUpdatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Equipment",
        key: "equipment-pieces",
        route: "/organization/equipment",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationEquipmentPiecesPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Crews",
        key: "crews",
        route: "/organization/crews",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationCrewsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Address",
        key: "create-address",
        route: "/organization/settings/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationAddressCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Edit Address",
        key: "edit-address",
        route: "/organization/addresses/:addressId",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationAddressEditPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Additional Costs",
        key: "additional-costs",
        route: "/organization/additional-costs",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationAdditionalCostsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Additional Cost",
        key: "create-additional-cost",
        route: "/organization/additional-costs/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationAdditionalCostCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Edit Additional Cost",
        key: "edit-additional-cost",
        route: "/organization/additional-costs/:additionalCostId",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationAdditionalCostEditPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Equipment Piece",
        key: "create-equipment-piece",
        route: "/organization/equipment/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationEquipmentPieceCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Edit Equipment Piece",
        key: "edit-equipment-piece",
        route: "/organization/equipment/:equipmentPieceId",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationEquipmentPieceEditPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },

      {
        name: "Plants",
        key: "plants",
        route: "/organization/plants",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationPlantsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Plant",
        key: "create-plant",
        route: "/organization/plants/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationPlantsCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Update Plant",
        key: "update",
        route: "/organization/plants/:plantId",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationPlantsEditPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Transfer Trucks",
        key: "transfer-trucks",
        route: "/organization/transfer-trucks",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationTransferTrucksPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Transfer Truck",
        key: "create-transfer-truck",
        route: "/organization/transfer-trucks/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationTransferTruckCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Update Transfer Truck",
        key: "update-transfer-truck",
        route: "/organization/transfer-trucks/:truckId",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationTransferTruckEditPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },

      {
        type: "internal",
        name: "Create Crew",
        key: "create-crew",
        route: "/organization/crews/create",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationCrewCreatePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Update Crew",
        key: "update-crew",
        route: "/organization/crews/:crewId",
        permission: UserPermissions.MANAGE_PRODUCT_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PRODUCT_SETTINGS}>
            <AuthWallSubscriber>
              <OrganizationCrewEditPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create Employee",
        key: "create-employee",
        route: "/organization/employees/create",
        permission: UserPermissions.MANAGE_EMPLOYEES,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_EMPLOYEES}>
            <AuthWallSubscriber>
              <CreateEmployeePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Update Employee",
        key: "update-employee",
        route: "/organization/employees/:employeeId/update",
        permission: UserPermissions.MANAGE_EMPLOYEES,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_EMPLOYEES}>
            <AuthWallSubscriber>
              <EditEmployeePage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Archived Employees",
        key: "archived-employees",
        route: "/organization/employees/archived",
        permission: UserPermissions.MANAGE_EMPLOYEES,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_EMPLOYEES}>
            <AuthWallSubscriber>
              <ArchivedEmployeesPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
    ],
  },
  {
    type: "collapse",
    name: "Organization Settings",
    key: "organization-settings",
    icon: <Icon fontSize="medium">settings</Icon>,
    collapse: [
      {
        name: "Users",
        key: "users.list",
        route: "/users",
        permission: UserPermissions.MANAGE_USERS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_USERS}>
            <UsersPage />
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Archived Users",
        key: "users.archived",
        route: "/users/archived",
        permission: UserPermissions.MANAGE_USERS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_USERS}>
            <ArchivedUsersPage />
          </AuthWall>
        ),
      },
      {
        name: "Data Imports",
        key: "data-uploads.list-data-uploads",
        route: "/data-imports",
        permission: UserPermissions.DO_DATA_IMPORTS,
        component: (
          <AuthWall permission={UserPermissions.DO_DATA_IMPORTS}>
            <AuthWallSubscriber>
              <DataUploadsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Import",
        key: "data-uploads.create-data-upload",
        route: "/data-imports/import",
        permission: UserPermissions.DO_DATA_IMPORTS,
        component: (
          <AuthWall permission={UserPermissions.DO_DATA_IMPORTS}>
            <AuthWallSubscriber>
              <DataUploadsImportPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Notification Triggers",
        key: "email-triggers.list-email-triggers",
        route: "/email-triggers",
        permission: UserPermissions.MANAGE_NOTIFICATION_TRIGGERS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_NOTIFICATION_TRIGGERS}>
            <AuthWallSubscriber>
              <NotificationsIndex />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Edit",
        type: "internal",
        key: "email-triggers.update-email-triggers",
        route: "/email-triggers/edit/:notificationId",
        permission: UserPermissions.MANAGE_NOTIFICATION_TRIGGERS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_NOTIFICATION_TRIGGERS}>
            <AuthWallSubscriber>
              <NotificationsEdit />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "Create",
        key: "email-triggers.create-email-triggers",
        route: "/email-triggers/create",
        permission: UserPermissions.MANAGE_NOTIFICATION_TRIGGERS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_NOTIFICATION_TRIGGERS}>
            <AuthWallSubscriber>
              <NotificationsCreate />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        type: "internal",
        name: "API Trigger Deliveries",
        key: "email-triggers.deliveries",
        route: "/email-triggers/:triggerId/deliveries",
        permission: UserPermissions.MANAGE_NOTIFICATION_TRIGGERS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_NOTIFICATION_TRIGGERS}>
            <AuthWallSubscriber>
              <ApiTriggerDeliveries />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Proposal Settings",
        key: "organization.proposal-settings",
        title: "Proposal Settings",
        route: "/organization/proposal-settings",
        permission: UserPermissions.MANAGE_PROPOSAL_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_PROPOSAL_SETTINGS}>
            <AuthWallSubscriber>
              <ProposalSettingsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Organization Info",
        key: "organization.settings",
        route: "/organization/settings",
        permission: UserPermissions.MANAGE_ORGANIZATION_INFO,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_ORGANIZATION_INFO}>
            <AuthWallSubscriber>
              <OrganizationSettingsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Subscription",
        key: "organization.subscription",
        route: "/organization/subscription",
        permission: UserPermissions.MANAGE_SUBSCRIPTION,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_SUBSCRIPTION}>
            <OrganizationSubscriptionPage />
          </AuthWall>
        ),
      },
      {
        name: "Email Settings",
        key: "organization.email-settings",
        title: "Email Settings",
        route: "/organization/email-settings",
        permission: UserPermissions.MANAGE_EMAIL_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_EMAIL_SETTINGS}>
            <AuthWallSubscriber>
              <EmailSettingsPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Email Sending",
        key: "organization.email-sending",
        title: "Email Sending",
        route: "/organization/email-sending",
        permission: UserPermissions.MANAGE_EMAIL_SETTINGS,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_EMAIL_SETTINGS}>
            <AuthWallSubscriber>
              <EmailSendingPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Employees",
        key: "employees",
        title: "Employees",
        route: "/organization/employees",
        permission: UserPermissions.MANAGE_EMPLOYEES,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_EMPLOYEES}>
            <AuthWallSubscriber>
              <EmployeesListPage />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reporting",
        key: "view-reports",
        title: "Reporting",
        route: "/organization/reporting",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsView />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/additional_cost_details",
        title: "Additional Cost Details",
        route: "/organization/report/additional_cost_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsAdditionalCostDetail />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/company_or_client_details",
        title: "Company or Client Details",
        route: "/organization/report/company_or_client_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsCompanyOrClientDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/contact_details",
        title: "Contact Details",
        route: "/organization/report/contact_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsContactDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/crew_details",
        title: "Crew Details",
        route: "/organization/report/crew_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsCrewDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/equipment_cost_details",
        title: "Equipment Cost Details",
        route: "/organization/report/equipment_cost_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsEquipmentCostDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/jobs_by_contact",
        title: "Jobs by Contact",
        route: "/organization/report/jobs_by_contact",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsJobsByContact />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/job_cost_by_product_type",
        title: "Job Cost by Product Type",
        route: "/organization/report/job_cost_by_product_type",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsJobCostByProductType />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/outstanding_work",
        title: "Outstanding Work",
        route: "/organization/report/outstanding_work",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsOutstandingWork />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/year_over_year_revenue",
        title: "Year over Year Revenue",
        route: "/organization/report/year_over_year_revenue",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsYearOverYearRevenue />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/job_costing_lapsed",
        title: "Job Costing Lapsed",
        route: "/organization/report/job_costing_lapsed",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsJobCostingLapsed />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/job_cost_detail",
        title: "Job Cost Detail",
        route: "/organization/report/job_cost_detail",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsJobCostDetail />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/job_details",
        title: "Job Details",
        route: "/organization/report/job_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsJobDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/organization_profitability",
        title: "Organization Profitability",
        route: "/organization/report/organization_profitability",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsOrganizationProfitability />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/product_details",
        title: "Product Details",
        route: "/organization/report/product_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsProductDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/proposal_details",
        title: "Proposal Details",
        route: "/organization/report/proposal_details",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsProposalDetails />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/sales_by_contact",
        title: "Sales by Contact",
        route: "/organization/report/sales_by_contact",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsSalesByContact />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/sales_by_product_summary",
        title: "Sales by Product Summary",
        route: "/organization/report/sales_by_product_summary",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsSalesByProductSummary />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/sales_by_proposal_source",
        title: "Sales by Proposal Source",
        route: "/organization/report/sales_by_proposal_source",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsSalesByProposalSource />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Reports",
        key: "reports/time_entries",
        title: "Time Entries",
        route: "/organization/report/time_entries",
        type: "internal",
        permission: UserPermissions.GENERATE_REPORTS,
        component: (
          <AuthWall permission={UserPermissions.GENERATE_REPORTS}>
            <AuthWallSubscriber>
              <ReportsTimeEntries />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Project Files",
        key: "projectFiles",
        title: "Project Files",
        route: "/project-files",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <ProjectFiles />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Linked Services",
        key: "services",
        title: "Linked Services",
        route: "/organization/linked-services",
        permission: UserPermissions.MANAGE_LINKED_SERVICES,
        component: (
          <AuthWall permission={UserPermissions.MANAGE_LINKED_SERVICES}>
            <AuthWallSubscriber>
              <OrganizationLinkedServices />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Finalize Linked Service",
        key: "FinalizeService",
        title: "Finalize Linked Service",
        route: "/organization/finalize-linked-service/:serviceName",
        permission: UserPermissions.MANAGE_LINKED_SERVICES,
        type: "internal",
        component: (
          <AuthWall permission={UserPermissions.MANAGE_LINKED_SERVICES}>
            <AuthWallSubscriber>
              <FinalizeOrganizationLinkedService />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },

      {
        name: "Quickbooks Settings",
        key: "QuickbooksSettings",
        title: "Quickbooks Settings",
        route: "/organization/linked-services/quickbooks/settings",
        type: "internal",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <QuickbooksSettings />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "Quickbooks Desktop Queue List",
        key: "QuickbooksDesktopQueueList",
        title: "Quickbooks Desktop Queue List",
        route: "/organization/linked-services/quickbooks-desktop/queue",
        type: "internal",
        component: (
          <AuthWall>
            <AuthWallSubscriber>
              <QuickbooksDesktopQueueList />
            </AuthWallSubscriber>
          </AuthWall>
        ),
      },
      {
        name: "User Permissions",
        key: "userPermissions",
        title: "User Permissions",
        route: "/organization/user-permissions",
        type: "internal",
        component: (
          <AuthWall>
            <AuthWallAdmin>
              <AuthWallSubscriber>
                <UserPermissionsPage />
              </AuthWallSubscriber>
            </AuthWallAdmin>
          </AuthWall>
        ),
      },
    ],
  },
] as const;

export default organizationRoutes;
